<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import slider from './components/Slider.vue'
import footerArea from './components/footer.vue'
import svgBox from './components/svgGreen.vue'

export default {
  page() {
    return {
      title: `主題策展`,
    }
  },
  components: {
    Slick,
    slider,
    footerArea,
    svgBox,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      type: 'techInside',
      mainColor: '#ABCD03',
      mainColorTwo: '#9abf00',
      sliderList: [],
      isMobile: false,
      showHamburger: false,
      theme: this.defaultValue.title,
      // themeTwo: this.defaultValue.description,
      themeDesc: this.defaultValue.introtext,
      slickOptions: {
        slidesToShow: 1, // 顯示個數
        slidesToScroll: 1, // 一次輪撥個數
        infinite: true, // 循環輪播
        touchThreshold: 3,
        arrows: false, // 箭頭
        pauseOnFocus: false,
        pauseOnHover: false,
        dots: true, // 底下點點
      },
      noProgress: true,
      slickProgress: 0,
      isPause: false,
      slickSpeed: 8000,
      slickProgressClock: null,
      list: this.defaultValue.slideshow,
      // list: [
      //   {
      //     imgsrc: 'https://picsum.photos/id/237/1920/800',
      //     title: '零壹主題策展1',
      //     desc: '副標文字測試副標文字測試副標文字測試 副標文字測試1',
      //   },
      // ],
    }
  },
  computed: {
    styleObject: function() {
      return {
        '--background-color': this.mainColor,
      }
    },
  },
  created() {
    this.sortList()
  },
  mounted() {
    if (window.innerWidth < 992) {
      this.isMobile = true
    }
  },
  destroyed() {
    clearInterval(this.slickProgressClock)
  },
  methods: {
    sortList() {
      this.sliderList.push(...this.defaultValue.featureTopics)
      this.sliderList.push(...this.defaultValue.futureTopics)
      this.sliderList.push(...this.defaultValue.pastTopics)
    },
    runProgressClock() {
      const timeout = 10
      this.slickProgressClock = setInterval(() => {
        if (!this.isPause) {
          this.slickProgress += 100 / (this.slickSpeed / timeout)

          if (this.slickProgress >= 100) {
            this.slickProgress = 0
            if (this.$refs.slick) {
              this.onNext()
            }
          }
        }
      }, timeout)
    },
    onNext() {
      this.$refs.slick.next()
    },
    onPrev() {
      this.$refs.slick.prev()
    },
    openHamburger() {
      this.showHamburger = true
    },
    nlToBr(string) {
      return string && string.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
  },
}
</script>
<template>
  <div class="exhibition">
    <div class="sectionOne">
      <div class="logo">
        <router-link :to="{ name: 'home' }" target="_blank">
          <img src="~@assets/images/TechInside/01logo1.png" alt="" />
        </router-link>
      </div>
      <!-- <div v-if="!isMobile" class="backArc">
        <img class="arcImg" src="~@assets/images/TechInside/banner_green.svg" alt="" :style="styleObject" />
        <img class="whiteBack" src="~@assets/images/TechInside/banner_green00.svg" alt="" />
        <div class="whiteBackBox"></div>
      </div> -->
      <svgBox :main-color="mainColor" :main-color-two="mainColorTwo" :width="'100%'"></svgBox>
      <div v-if="!isMobile" class="atag">
        <!-- <a href="https://www.zerone.com.tw/" class="atag-hover" style="margin-right:45px;">零壹官網</a> -->
        <router-link :to="{ name: 'search' }" class="atag-hover" target="_blank">全站搜尋</router-link>
      </div>
      <Transition name="fade">
        <div v-if="isMobile" class="mobileATag" @click="openHamburger">
          <font-awesome-icon v-if="!showHamburger" style="color:white;" :icon="['fal', 'bars']"></font-awesome-icon>
          <div v-if="showHamburger" class="hamburger">
            <!-- <a href="https://www.zerone.com.tw/">零壹官網</a> -->
            <router-link :to="{ name: 'search' }" class="atag-hover">全站搜尋</router-link>
          </div>
        </div>
      </Transition>
      <Slick ref="slick" :options="slickOptions" class="SectionBanner__carouselList slick isStyleSlideshow">
        <div v-for="(item, index) of list" :key="index" @mouseenter="isPause = true" @mouseleave="isPause = false">
          <img :src="item.path" alt="" style="width: 100%;" class="SectionBanner__carouselList__img" />
          <div class="content">
            <p class="title">{{ item.title }}</p>
            <p v-if="!isMobile" class="desc"> {{ item.subtitle }}</p>
          </div>
        </div>
      </Slick>
      <div v-if="list.length > 1 && !isMobile" class="navigation">
        <button class="navigation__btn navigation__prev" @click="onPrev" @mouseenter="isPause = true" @mouseleave="isPause = false">
          <i class="navigation__icon fal fa-chevron-left"></i>
        </button>
        <button class="navigation__btn navigation__next" @click="onNext" @mouseenter="isPause = true" @mouseleave="isPause = false">
          <i class="navigation__icon fal fa-chevron-right"></i>
        </button>
      </div>
      <div v-if="list.length > 1" class="progress" :style="{ width: `${slickProgress}%` }"> </div>
      <Transition name="fade">
        <div v-if="showHamburger" class="dialogShadow" @click="showHamburger = false"></div>
      </Transition>
    </div>
    <div class="sectionTwo">
      <img class="arcLine" src="~@assets/images/TechInside/curve.svg" alt="" :style="styleObject" />
      <p class="theme">{{ theme }}</p>
      <!-- <p class="theme">{{ themeTwo }}</p> -->
      <p class="themeDesc" v-html="nlToBr(themeDesc)"></p>
    </div>
    <div class="sectionThree">
      <slider :list="sliderList" :first-alias="defaultValue.alias"></slider>
    </div>
    <footer-area :main-color="mainColor"></footer-area>
    <router-link target="_blank" :to="{ name: 'contact' }">
      <div class="contact" :style="styleObject">
        <i class="fas fa-envelope"></i>
      </div>
    </router-link>
  </div>
</template>
<style lang="scss" scoped>
.exhibition {
  .contact {
    position: fixed;
    bottom: 90px;
    right: 12px;
    width: 60px;
    height: 60px;
    border-radius: 35px;
    background-color: var(--background-color);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 12px;
    cursor: pointer;
    color: #ffffff;
    border: 1px solid #ffffff;
    box-shadow: 0px 10px 15px #4e7b1b29;
    z-index: 5;
    @media screen and (max-width: 400px) {
      width: 44px;
      height: 44px;
      bottom: 70px;
    }
    > i {
      margin-left: 4px;
      scale: 1.5;
    }
  }
  .sectionOne {
    width: 100%;
    // height: 550px;
    background: #000000;
    position: relative;
    // @include max-lg {
    //   height: 440px;
    // }
    // .backArc {
    //   width: 100%;
    //   height: 210px;
    //   position: absolute;
    //   top: 75%;
    //   z-index: 5;
    //   @include max-xl {
    //     top: 75%;
    //   }
    //   @media screen and (max-width: 1470px) {
    //     top: 73%;
    //   }
    //   @media screen and (max-width: 1400px) {
    //     top: 71%;
    //   }
    //   @media screen and (max-width: 1300px) {
    //     top: 70%;
    //   }
    //   @media screen and (max-width: 1200px) {
    //     top: 65%;
    //   }
    //   @media screen and (max-width: 1100px) {
    //     top: 60%;
    //   }
    //   @include max-lg {
    //     top: 50%;
    //   }
    //   @include max-lg {
    //     top: 40%;
    //   }
    //   @include max-md {
    //     top: 32%;
    //   }
    //   @include max-sm {
    //     top: 42%;
    //   }
    //   @media screen and (max-width: 360px) {
    //     top: 20%;
    //   }
    //   .arcImg {
    //     width: 100%;
    //     height: 210px;
    //     scale: 1.1;
    //   }
    //   .whiteBack {
    //     margin-top: -185px;
    //     @media screen and (max-width: 1100px) {
    //       margin-top: -210px;
    //     }
    //     @include max-md {
    //       margin-top: -210px;
    //     }
    //   }
    //   .whiteBackBox {
    //     margin-top: -58px;
    //     height: 80px;
    //     background-color: #ffffff;
    //     @media screen and (max-width: 1200px) {
    //       margin-top: -80px;
    //     }

    //     @media screen and (max-width: 1200px) {
    //       margin-top: -80px;
    //     }
    //     @include max-lg {
    //       height: 250px;
    //     }
    //     @include max-md {
    //       margin-top: -99px;
    //     }
    //     @include max-sm {
    //       margin-top: -105px;
    //     }
    //     @media screen and (max-width: 360px) {
    //       margin-top: -113px;
    //     }
    //   }
    // }
    .logo {
      z-index: 5;
      width: 160px;
      height: 70px;
      position: absolute;
      left: 135px;
      top: 30px;
      cursor: pointer;
      @include max-lg {
        width: 120px;
        height: 50px;
        left: 70px;
      }
      @include max-sm {
        width: 95px;
        left: 40px;
      }
      @media screen and (max-width: 400px) {
        left: 20px;
        top: 5px;
      }
    }
    .atag {
      z-index: 5;
      position: absolute;
      top: 30px;
      right: 125px;
      cursor: pointer;
      .atag-hover {
        color: $color-gray-1;
        transition: color, 0.5s;
        &:hover {
          color: $color-primary;
          text-decoration: none;
        }
      }
    }
    .mobileATag {
      position: absolute;
      top: 3%;
      right: 3%;
      z-index: 11;
      scale: 1.3;
      cursor: pointer;
      .hamburger {
        padding: 5px;
        background: #ffffffdb;
        color: #000000;
        display: flex;
        flex-direction: column;
        a {
          padding: 5px 5px;
          color: #000000;
          font-size: 14px;
          text-decoration: none;
        }
      }
    }
    .content {
      position: absolute;
      top: 35%;
      margin-left: 250px;
      animation-name: titleMove;
      animation-duration: 1s;
      @include max-xl {
        margin-left: 150px;
      }
      @include max-lg {
        top: 40%;
        margin-left: 130px;
      }
      @include max-md {
        margin-left: 100px;
      }
      @include max-sm {
        top: 40%;
        margin-left: 70px;
      }
      .title {
        color: $color-gray-1;
        font-size: 72px;
        font-weight: 500;
        @include max-xl {
          font-size: 50px;
        }
        @include max-lg {
          font-size: 40px;
        }
        @include max-md {
          font-size: 30px;
        }
        @include max-sm {
          font-size: 24px;
        }
      }
      .desc {
        color: $color-gray-1;
        font-size: 30px;
        margin-top: 24px;
        max-width: 570px;
        @include max-xl {
          font-size: 20px;
          margin-top: 16px;
        }
      }
    }
  }
  .sectionTwo {
    min-height: 55vh;
    margin: 150px 0;
    position: relative;
    .arcLine {
      width: 100%;
      position: absolute;
      top: 10%;
      scale: 1.2;
      @include max-lg {
        top: 10%;
      }
    }
    @media screen and (max-width: 1300px) {
      margin: 120px 0;
    }
    @include max-lg {
      min-height: 40vh;
      margin: 80px 0;
    }
    @include max-md {
      min-height: 25vh;
      margin: 80px 0;
    }
    .theme {
      font-size: 58px;
      font-weight: 500;
      margin-bottom: 0;
      text-align: center;
      width: 70%;
      margin: 0 auto;
      @include max-xl {
        font-size: 36px;
      }
      @include max-lg {
        font-size: 30px;
      }
      @include max-md {
        font-size: 20px;
        margin: 0 auto;
      }
      @include max-sm {
        font-size: 16px;
      }
    }
    .themeDesc {
      width: 75%;
      margin: 50px auto 0px;
      font-size: 22px;
      line-height: 2;
      @include max-lg {
        width: 80%;
      }
      @include max-md {
        font-size: 14px;
        margin: 25px auto 0px;
      }
    }
  }
  .sectionThree {
    margin-top: 100px;
    margin-bottom: 200px;
    @media screen and (max-width: 400px) {
      margin-top: 150px;
      margin-bottom: 150px;
    }
  }
  .dialogShadow {
    position: absolute;
    width: 100%;
    height: 100vh;
    background: #000000b0;
    z-index: 10;
    top: 0%;
    transition: all, 0.5s;
  }
  .navigation {
    &__icon {
      background-color: $color-gray-1;
      color: $color-primary;
    }
    &__btn {
      position: absolute;
      top: 50%;
      z-index: 0;
      display: flex;
      width: calc(((100vw - #{$container-menu}) / 2) + 4rem);
      height: 100%;
      pointer-events: auto;
      background: transparent;
      border: unset;
      transform: translateY(-50%);
      appearance: none;

      @media screen and (max-width: $container-menu) {
        width: 100px;
      }

      &:focus {
        outline: none;
      }

      &:hover {
        .navigation {
          &__icon {
            color: #fff;
            background: $color-primary;
            border-color: $color-primary;
            opacity: 1;
            @include max-md {
              color: $color-primary;
              background: transparent;
              border-color: transparent;
              opacity: 1;
            }
          }
        }
      }

      &:active {
        outline: none;

        .navigation {
          &__icon {
            opacity: 0.75;
          }
        }
      }
    }

    &__prev {
      left: 0;
      align-items: center;
      justify-content: flex-end;

      @media screen and (max-width: $container-menu) {
        justify-content: flex-start;
        padding-left: 2rem;
      }
      @include max-md {
        padding-left: 10px;
      }
    }

    &__next {
      right: 0;
      align-items: center;
      justify-content: flex-start;

      @media screen and (max-width: $container-menu) {
        justify-content: flex-end;
        padding-right: 2rem;
      }
      @include max-md {
        padding-right: 10px;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 53px;
      height: 53px;
      color: $color-primary;
      border: unset;
      border-radius: 100%;
      box-shadow: 0 32px 84px #0e567c2a;
      transition: border 0.3s, color 0.3s, background 0.3s;
      @include max-lg {
        width: 33px;
        height: 33px;
      }
      @include max-md {
        color: #8c97ab;
        border: 0;
        font-size: 20px;
        font-weight: 500;
        box-shadow: 0;
      }
    }
  }
  @keyframes titleMove {
    from {
      top: 45%;
      opacity: 0;
    }
    to {
      top: 35%;
      opacity: 1;
    }
  }
  .progress {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 6px;
    background: $color-primary;
    transition: width 0s;
    // @include max-md {
    //   display: none;
    // }
  }
}
</style>
